import {
  useCreateUser,
  useUpdateUser,
} from '@/core/domain/enterprise/Users/Users.hooks';
import {
  UserFormValues,
  UserReduced,
} from '@/core/domain/enterprise/Users/Users.types';
import useSession from '@/hooks/useSession';
import { Form, Modal, ModalProps } from 'antd';
import { useCallback, useEffect } from 'react';
import UserForm from '../UserForm';

type Props = Omit<ModalProps, 'onCancel'> & {
  user?: UserReduced;
  onCancel: VoidFunction;
};

const UserModalForm: React.FC<Props> = ({ user, ...props }) => {
  const [form] = Form.useForm<UserFormValues>();

  const session = useSession();

  const userCreate = useCreateUser();
  const userUpdate = useUpdateUser();

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        email: user.email,
        login: user.login,
        profileId: user?.profileId,
        employeeId: user.employeeId,
      });
    }
  }, [user]);

  const handleSubmit = useCallback(async () => {
    try {
      const values = await form.validateFields();

      const submit = async () => {
        if (user) {
          await userUpdate.mutateAsync({
            ...values,
            profilesId: [values.profileId],
            id: user.id,
          });
        } else {
          await userCreate.mutateAsync({
            ...values,
            profilesId: [values.profileId],
          });
        }
        handleClose();
      };

      if (session?.user_name !== user?.login) {
        return submit();
      }

      Modal.confirm({
        title: 'Confirmar atualização da conta',
        content: (
          <>
            <p>
              Você está atualizando seus próprios dados de acesso. tem certeza
              dessa ação?
            </p>

            <div>
              <span style={{ color: 'darkgray' }}>Novo Login</span>
              <strong style={{ display: 'block' }}>{values.login}</strong>
            </div>

            <div style={{ marginBottom: 16 }}>
              <span style={{ color: 'darkgray' }}>Novo E-mail</span>
              <strong style={{ display: 'block' }}>{values.email}</strong>
            </div>
          </>
        ),
        okText: 'Salvar',
        onOk: () => submit(),
      });
    } catch {}
  }, [session, user]);

  function handleClose() {
    if (props.onCancel) {
      props.onCancel();
    }
    form.resetFields();
  }

  return (
    <Modal
      {...props}
      onCancel={handleClose}
      onOk={handleSubmit}
      title={`${user ? 'Edição' : 'Cadastro'} de usuário`}
      okText="Salvar"
      confirmLoading={userCreate.isLoading || userUpdate.isLoading}
    >
      <UserForm form={form} isEdit={!!user} />
    </Modal>
  );
};

export default UserModalForm;
